import { render, staticRenderFns } from "./PearsonNav.vue?vue&type=template&id=6827625e&scoped=true"
import script from "./PearsonNav.vue?vue&type=script&lang=js"
export * from "./PearsonNav.vue?vue&type=script&lang=js"
import style0 from "./PearsonNav.vue?vue&type=style&index=0&id=6827625e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827625e",
  null
  
)

export default component.exports